import { render, staticRenderFns } from "./IgmpSnoopList.vue?vue&type=template&id=455fccaa&"
import script from "./IgmpSnoopList.vue?vue&type=script&lang=js&"
export * from "./IgmpSnoopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports